import { Injectable } from '@angular/core';
import { ArrayLiteralValue, LiteralValueModel, OptionModel, PathValueModel, SelectModel, SelectTextValue, ValueID, ValueModel } from '../../form-json.types';
import { DataService } from '../data/data.service';
import { FormCoreModule } from '../form-core.module';

@Injectable({
  providedIn: FormCoreModule
})
export class ValueService {

  constructor(private data: DataService) { }

  assign(value: ValueID) {
    const model = this.data.getModel<ValueModel>(value)
    switch (model.type) {
      case 'path-value':
        return this.pathValue(model)
      case 'literal-value':
        return this.literValue(model)
      case 'array-literal-value':
        return this.arrayLiteralValue(model)
      case 'select-text-value':
        return this.selectTextValue(model)
    }
  }

  private pathValue(path: PathValueModel) {
    if (path.attributes.path.indexOf('.') > -1 && path.attributes.path.split('.')[0]==='queryParams') return this.data.queryParams[path.attributes.path.split('.')[1]]
    if (this.data.pathValue.hasOwnProperty(path.attributes.path)) return this.data.pathValue[path.attributes.path]
    return this.data.getControl(path.attributes.path).value
  }

  private literValue(literal: LiteralValueModel) {
    return literal.attributes.literal
  }

  private arrayLiteralValue(arrayLiteral: ArrayLiteralValue) {
    return [...arrayLiteral.attributes.array]
  }

  private selectTextValue(select: SelectTextValue) {
    const component = this.data.getModel<SelectModel>(select.relationships.component.data)
    const value = this.data.getControl(component.attributes.path).value
    const options = component.relationships.options.data.map(option => this.data.getModel<OptionModel>(option))
    return options.find(option => option.attributes.value === value)?.attributes.text
  }
}
